import { render, staticRenderFns } from "./PoultryManagement.vue?vue&type=template&id=b8f9f066&scoped=true&lang=html&"
import script from "./PoultryManagement.vue?vue&type=script&lang=js&"
export * from "./PoultryManagement.vue?vue&type=script&lang=js&"
import style0 from "./PoultryManagement.vue?vue&type=style&index=0&id=b8f9f066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f9f066",
  null
  
)

export default component.exports